import useValidationMessage from "../hooks/useValidationMessage";

export default () => {
    const { getMessage } = useValidationMessage();
    return {
        login: {
            email: { message: getMessage('email', 'required') },
            password: { message: getMessage('password', 'required') },
        },
        user: {
            firstname: { message: getMessage('firstname', 'required') },
            lastname: { message: getMessage('lastname', 'required') },
            email: { message: getMessage('email', 'required') },
            phone: { message: getMessage('phone', 'required') },
            password: { message: getMessage('password', 'required') },
            userrole: { message: getMessage('userrole', 'required') },
            managerid: { message: getMessage('managerid', 'required') },
        },
        contact: {
            firstname: { message: getMessage('firstname', 'required') },
            lastname: { message:getMessage('lastname', 'required') },
            // phone: { message: validationMessages.phone.required },
            title: { message: getMessage('title', 'required')},
        },
        lead: {
            lead_name: { message: getMessage('lead_name', 'required') },
            leadtype: {message: getMessage('leadtype', 'required')},
            lead_status: {message: getMessage('lead_status', 'required')},
            phone: {message: getMessage('phone', 'required')},
            owner_id: {message: getMessage('owner_id', 'required')},
            customer_type: {message: getMessage('customer_type', 'required')},
            city: {message: getMessage('city', 'required')},
        }
    }
};